import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M6.42,9.71l-1-1H9.5a1,1,0,0,0,0-2H5.41l1-1A1,1,0,0,0,5,4.29L2.29,7a.93.93,0,0,0-.21.33,1,1,0,0,0,0,.76,1.15,1.15,0,0,0,.21.33L5,11.12a1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3A1,1,0,0,0,6.42,9.71Z"/><path d="M29.92,8.09a1,1,0,0,0,0-.76A.93.93,0,0,0,29.71,7L27,4.29a1,1,0,0,0-1.42,1.42l1,1H22.5a1,1,0,1,0,0,2h4.09l-1,1a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l2.71-2.7A1.15,1.15,0,0,0,29.92,8.09Z"/><path d="M25.59,14.47l-6.13-.78V8.53a3.46,3.46,0,1,0-6.91,0V19.25c-1-.45-1.79-.82-1.94-.88a3.45,3.45,0,0,0-3.92,1.19A3.39,3.39,0,0,0,6,22.12,3.45,3.45,0,0,0,7.38,24.4l6.55,4.91A3.46,3.46,0,0,0,16,30h9.57a2.64,2.64,0,0,0,2.62-2.31l1.06-8.45A4.3,4.3,0,0,0,25.59,14.47Z"/>';
export var SwipeSVG = function SwipeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SwipeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SwipeSVG);